import type { FC } from 'react';
import { useDrop } from 'react-dnd';

import classNames from 'classnames';

import { useDndRef } from '@iconik-io/shared-lib/src/react/hooks/use_dnd_ref';

import DraggableTypes from '../../../constants/draggable_types';
import type { DragAndDropHSide } from '../types';

import styles from './column_drop_target.module.css';

type Props = {
  index: number;
  side: DragAndDropHSide;
  isActive: boolean;
  onHover: (index: number, side: DragAndDropHSide) => void;
};

const ColumnDropTarget: FC<Props> = ({ index, side, isActive, onHover }) => {
  const [, dropRef] = useDrop(
    () => ({
      accept: DraggableTypes.TABLE_COLUMN,
      hover: () => {
        onHover(index, side);
      },
    }),
    [index, side],
  );
  const dropTargetRef = useDndRef(dropRef);
  return (
    <div
      ref={dropTargetRef}
      className={classNames(
        styles.root,
        { [styles.active]: isActive },
        { [styles.left]: side === 'left' },
        { [styles.right]: side === 'right' },
      )}
      data-index={index}
    />
  );
};

export default ColumnDropTarget;
